import { render, staticRenderFns } from "./UserDialog.vue?vue&type=template&id=48e36167"
import script from "./UserDialog.vue?vue&type=script&lang=js"
export * from "./UserDialog.vue?vue&type=script&lang=js"
import style0 from "./UserDialog.vue?vue&type=style&index=0&id=48e36167&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports